module.exports = __webpack_public_path__ + "static/frame-835c16550314527b1f1a9bee4ffc220c.png";